// extracted by mini-css-extract-plugin
export var categoryCell = "lpCompetitorTable-module--categoryCell--b0950";
export var categoryColumn = "lpCompetitorTable-module--categoryColumn--fa7d9";
export var categoryLabel = "lpCompetitorTable-module--categoryLabel--41d63";
export var cellContent = "lpCompetitorTable-module--cellContent--1e537";
export var checkmark = "lpCompetitorTable-module--checkmark--a535c";
export var companyColumn = "lpCompetitorTable-module--companyColumn--ce500";
export var companyName = "lpCompetitorTable-module--companyName--9ecdd";
export var container = "lpCompetitorTable-module--container--5fe72";
export var contentCell = "lpCompetitorTable-module--contentCell--ed6e1";
export var desktopOnly = "lpCompetitorTable-module--desktopOnly--9147e";
export var headerContainer = "lpCompetitorTable-module--headerContainer--4c06a";
export var mangomintCell = "lpCompetitorTable-module--mangomintCell--ee12f";
export var mobileOnly = "lpCompetitorTable-module--mobileOnly--b604f";
export var ratingItem = "lpCompetitorTable-module--ratingItem--7b81b";
export var ratingsContainer = "lpCompetitorTable-module--ratingsContainer--ac2ed";
export var star = "lpCompetitorTable-module--star--d1216";
export var starRating = "lpCompetitorTable-module--starRating--b26a9";
export var table = "lpCompetitorTable-module--table--6e415";
export var tableContainer = "lpCompetitorTable-module--tableContainer--7a4ea";
export var tableHeader = "lpCompetitorTable-module--tableHeader--bbdb2";
export var tableRow = "lpCompetitorTable-module--tableRow--dc044";